/*****************************************************************************
 * PROJECT NAME   : SEC 회의실관리 프로젝트
 * SUBSYSTEM NAME : Admin
 * FILE NAME      : main.js
 * DESCRIPTION    : 전역 설정 파일
 *
 * VERSION NO     author           date        content  -> info
 * ----------------------------------------------------------------------------
 *    1.0       K.Hur      2021-09-27      init
 *****************************************************************************/

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import mixins from './mixins'
import store from './store'
import axios from 'axios'
import LoadingBlock from './components/LoadingBlock'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import {ArrowRightBold, ArrowLeftBold, Edit} from '@element-plus/icons'
// import VueCookies  from 'vue-cookies'
// import VShowSlide from 'v-show-slide'


const app = createApp(App)
app.use(router)
app.mixin(mixins)
app.use(store)
app.use(ElementPlus)
// app.use(VueCookies)
// app.$cookies.config("7d");
// app.use(VShowSlide)

app.config.globalProperties.axios = axios
app.component('LoadingBlock', LoadingBlock)
app.component('arrow-right-bold', ArrowRightBold)
app.component('arrow-left-bold', ArrowLeftBold)
app.component('edit', Edit)
app.mount('#app')


